"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectBatchForDispenseSchema = exports.selectPriceSchema = exports.selectPriceShape = void 0;
const zod_1 = require("zod");
const price_list_schema_1 = require("./price-list.schema");
exports.selectPriceShape = {
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    listType: zod_1.z.enum(price_list_schema_1.PRICE_LIST_TYPES),
    asOfDate: zod_1.z.coerce.date().optional(),
};
exports.selectPriceSchema = zod_1.z.object(exports.selectPriceShape);
exports.selectBatchForDispenseSchema = zod_1.z.object({
    ...exports.selectPriceShape,
    locationId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=price-selection.schema.js.map